module.exports = __webpack_public_path__ + "static/media/bull_call_spread.982f1aac.png";